import {TrafficManagementClientBase} from './TrafficManagementClientBase';
import {throwException, isAxiosError} from './TrafficManagementClientBase';
import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';

export class LocationClient extends TrafficManagementClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param easting (optional)
     * @param northing (optional)
     * @return Success
     */
    bngToLatLong(easting: number | undefined, northing: number | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Location?";
        if(easting === null)
            throw new Error("The parameter 'easting' cannot be null.");
        else if(easting !== undefined)
            url_ += "easting=" + encodeURIComponent("" + easting) + "&";
        if(northing === null)
            throw new Error("The parameter 'northing' cannot be null.");
        else if(northing !== undefined)
            url_ += "northing=" + encodeURIComponent("" + northing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBngToLatLong(_response);
        });
    }

    protected processBngToLatLong(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === "object") {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

/**
* @param easting (optional)
* @param northing (optional)
* @return Success
*/
    bngToAddress(easting: number | undefined, northing: number | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Location/BngToAddress?";
        if (easting === null)
            throw new Error("The parameter 'easting' cannot be null.");
        else if (easting !== undefined)
            url_ += "easting=" + encodeURIComponent("" + easting) + "&";
        if (northing === null)
            throw new Error("The parameter 'northing' cannot be null.");
        else if (northing !== undefined)
            url_ += "northing=" + encodeURIComponent("" + northing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBngToAddress(_response);
        });
    }

    protected processBngToAddress(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}